import { StyledIcon } from 'fitify-ui/src/Icon/Icon.Styled'
import { styled } from 'styled-components'

export const StyledLogoWrapper = styled.div`
  display: flex;

  ${StyledIcon} {
    width: 63px;
    height: 28px;
    color: ${({ theme }) => theme.colors['N Content/Primary']};
  }
`
